import { createContext, useContext } from 'react';

export const TranslateContext = createContext<string>('');

/**
 * Este contexto es usado en principio para la traducción de archivos, para
 * hacerle llegar al uploader el id de traducción.
 *
 * @returns El string que representa el id del lenguaje que se está traduciendo
 */
export function useTranslateId() {
  const langId = useContext(TranslateContext);

  return langId;
}
